/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteRouteImport } from './routes/_onboarding/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as OnboardingOrgsIndexRouteImport } from './routes/_onboarding/orgs.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppHomeIndexRouteImport } from './routes/_app/home/index'
import { Route as OnboardingOrgsOnboardingRouteImport } from './routes/_onboarding/orgs.onboarding'
import { Route as AuthInvitesInviteTokenRouteImport } from './routes/_auth/invites.$inviteToken'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppHomeDirectivesRouteImport } from './routes/_app/home/directives'
import { Route as AppHomeUsersRouteRouteImport } from './routes/_app/home/users/route'
import { Route as AppHomeOverviewRouteRouteImport } from './routes/_app/home/overview/route'
import { Route as AppHomeUsersIndexRouteImport } from './routes/_app/home/users/index'
import { Route as AppHomeOverviewIndexRouteImport } from './routes/_app/home/overview/index'
import { Route as AppHomeUsersActorIdRouteImport } from './routes/_app/home/users/$actorId'
import { Route as AppHomeSentencesSentenceIdRouteImport } from './routes/_app/home/sentences/$sentenceId'
import { Route as AppHomePraetorsPraetorIdRouteRouteImport } from './routes/_app/home/praetors/$praetorId/route'
import { Route as AppHomePraetorsPraetorIdIndexRouteImport } from './routes/_app/home/praetors/$praetorId/index'
import { Route as AppHomeOverviewOnboardingSdkRouteImport } from './routes/_app/home/overview/onboarding/sdk'
import { Route as AppHomePraetorsPraetorIdPoliciesRouteRouteImport } from './routes/_app/home/praetors/$praetorId/policies/route'
import { Route as AppHomePraetorsPraetorIdCasesRouteRouteImport } from './routes/_app/home/praetors/$praetorId/cases/route'
import { Route as AppHomePraetorsPraetorIdSettingsIndexRouteImport } from './routes/_app/home/praetors/$praetorId/settings/index'
import { Route as AppHomePraetorsPraetorIdPoliciesIndexRouteImport } from './routes/_app/home/praetors/$praetorId/policies/index'
import { Route as AppHomePraetorsPraetorIdCasesIndexRouteImport } from './routes/_app/home/praetors/$praetorId/cases/index'
import { Route as AppHomePraetorsPraetorIdPoliciesPolicyIdRouteImport } from './routes/_app/home/praetors/$praetorId/policies/$policyId'
import { Route as AppHomePraetorsPraetorIdCasesCaseIdRouteImport } from './routes/_app/home/praetors/$praetorId/cases/$caseId'
import { Route as AppHomePraetorsPraetorIdCasesV2RouteRouteImport } from './routes/_app/home/praetors/$praetorId/cases/v2/route'
import { Route as AppHomePraetorsPraetorIdCasesV2IndexRouteImport } from './routes/_app/home/praetors/$praetorId/cases/v2/index'
import { Route as AppHomePraetorsPraetorIdCasesV2CaseIdRouteImport } from './routes/_app/home/praetors/$praetorId/cases/v2/$caseId'

const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/_auth/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/_auth/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const OnboardingOrgsIndexRoute = OnboardingOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppHomeIndexRoute = AppHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AppRouteRoute,
} as any)
const OnboardingOrgsOnboardingRoute =
  OnboardingOrgsOnboardingRouteImport.update({
    id: '/orgs/onboarding',
    path: '/orgs/onboarding',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const AuthInvitesInviteTokenRoute = AuthInvitesInviteTokenRouteImport.update({
  id: '/_auth/invites/$inviteToken',
  path: '/invites/$inviteToken',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppHomeDirectivesRoute = AppHomeDirectivesRouteImport.update({
  id: '/home/directives',
  path: '/home/directives',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeUsersRouteRoute = AppHomeUsersRouteRouteImport.update({
  id: '/home/users',
  path: '/home/users',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeOverviewRouteRoute = AppHomeOverviewRouteRouteImport.update({
  id: '/home/overview',
  path: '/home/overview',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeUsersIndexRoute = AppHomeUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHomeUsersRouteRoute,
} as any)
const AppHomeOverviewIndexRoute = AppHomeOverviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHomeOverviewRouteRoute,
} as any)
const AppHomeUsersActorIdRoute = AppHomeUsersActorIdRouteImport.update({
  id: '/$actorId',
  path: '/$actorId',
  getParentRoute: () => AppHomeUsersRouteRoute,
} as any)
const AppHomeSentencesSentenceIdRoute =
  AppHomeSentencesSentenceIdRouteImport.update({
    id: '/home/sentences/$sentenceId',
    path: '/home/sentences/$sentenceId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdRouteRoute =
  AppHomePraetorsPraetorIdRouteRouteImport.update({
    id: '/home/praetors/$praetorId',
    path: '/home/praetors/$praetorId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdIndexRoute =
  AppHomePraetorsPraetorIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppHomePraetorsPraetorIdRouteRoute,
  } as any)
const AppHomeOverviewOnboardingSdkRoute =
  AppHomeOverviewOnboardingSdkRouteImport.update({
    id: '/onboarding/sdk',
    path: '/onboarding/sdk',
    getParentRoute: () => AppHomeOverviewRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdPoliciesRouteRoute =
  AppHomePraetorsPraetorIdPoliciesRouteRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AppHomePraetorsPraetorIdRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesRouteRoute =
  AppHomePraetorsPraetorIdCasesRouteRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => AppHomePraetorsPraetorIdRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdSettingsIndexRoute =
  AppHomePraetorsPraetorIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppHomePraetorsPraetorIdRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdPoliciesIndexRoute =
  AppHomePraetorsPraetorIdPoliciesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppHomePraetorsPraetorIdPoliciesRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesIndexRoute =
  AppHomePraetorsPraetorIdCasesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppHomePraetorsPraetorIdCasesRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdPoliciesPolicyIdRoute =
  AppHomePraetorsPraetorIdPoliciesPolicyIdRouteImport.update({
    id: '/$policyId',
    path: '/$policyId',
    getParentRoute: () => AppHomePraetorsPraetorIdPoliciesRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesCaseIdRoute =
  AppHomePraetorsPraetorIdCasesCaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => AppHomePraetorsPraetorIdCasesRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesV2RouteRoute =
  AppHomePraetorsPraetorIdCasesV2RouteRouteImport.update({
    id: '/v2',
    path: '/v2',
    getParentRoute: () => AppHomePraetorsPraetorIdCasesRouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesV2IndexRoute =
  AppHomePraetorsPraetorIdCasesV2IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppHomePraetorsPraetorIdCasesV2RouteRoute,
  } as any)
const AppHomePraetorsPraetorIdCasesV2CaseIdRoute =
  AppHomePraetorsPraetorIdCasesV2CaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => AppHomePraetorsPraetorIdCasesV2RouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/home/overview': typeof AppHomeOverviewRouteRouteWithChildren
  '/home/users': typeof AppHomeUsersRouteRouteWithChildren
  '/home/directives': typeof AppHomeDirectivesRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/invites/$inviteToken': typeof AuthInvitesInviteTokenRoute
  '/orgs/onboarding': typeof OnboardingOrgsOnboardingRoute
  '/home/': typeof AppHomeIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/orgs/': typeof OnboardingOrgsIndexRoute
  '/home/praetors/$praetorId': typeof AppHomePraetorsPraetorIdRouteRouteWithChildren
  '/home/sentences/$sentenceId': typeof AppHomeSentencesSentenceIdRoute
  '/home/users/$actorId': typeof AppHomeUsersActorIdRoute
  '/home/overview/': typeof AppHomeOverviewIndexRoute
  '/home/users/': typeof AppHomeUsersIndexRoute
  '/home/praetors/$praetorId/cases': typeof AppHomePraetorsPraetorIdCasesRouteRouteWithChildren
  '/home/praetors/$praetorId/policies': typeof AppHomePraetorsPraetorIdPoliciesRouteRouteWithChildren
  '/home/overview/onboarding/sdk': typeof AppHomeOverviewOnboardingSdkRoute
  '/home/praetors/$praetorId/': typeof AppHomePraetorsPraetorIdIndexRoute
  '/home/praetors/$praetorId/cases/v2': typeof AppHomePraetorsPraetorIdCasesV2RouteRouteWithChildren
  '/home/praetors/$praetorId/cases/$caseId': typeof AppHomePraetorsPraetorIdCasesCaseIdRoute
  '/home/praetors/$praetorId/policies/$policyId': typeof AppHomePraetorsPraetorIdPoliciesPolicyIdRoute
  '/home/praetors/$praetorId/cases/': typeof AppHomePraetorsPraetorIdCasesIndexRoute
  '/home/praetors/$praetorId/policies/': typeof AppHomePraetorsPraetorIdPoliciesIndexRoute
  '/home/praetors/$praetorId/settings/': typeof AppHomePraetorsPraetorIdSettingsIndexRoute
  '/home/praetors/$praetorId/cases/v2/$caseId': typeof AppHomePraetorsPraetorIdCasesV2CaseIdRoute
  '/home/praetors/$praetorId/cases/v2/': typeof AppHomePraetorsPraetorIdCasesV2IndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/home/directives': typeof AppHomeDirectivesRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/invites/$inviteToken': typeof AuthInvitesInviteTokenRoute
  '/orgs/onboarding': typeof OnboardingOrgsOnboardingRoute
  '/home': typeof AppHomeIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/orgs': typeof OnboardingOrgsIndexRoute
  '/home/sentences/$sentenceId': typeof AppHomeSentencesSentenceIdRoute
  '/home/users/$actorId': typeof AppHomeUsersActorIdRoute
  '/home/overview': typeof AppHomeOverviewIndexRoute
  '/home/users': typeof AppHomeUsersIndexRoute
  '/home/overview/onboarding/sdk': typeof AppHomeOverviewOnboardingSdkRoute
  '/home/praetors/$praetorId': typeof AppHomePraetorsPraetorIdIndexRoute
  '/home/praetors/$praetorId/cases/$caseId': typeof AppHomePraetorsPraetorIdCasesCaseIdRoute
  '/home/praetors/$praetorId/policies/$policyId': typeof AppHomePraetorsPraetorIdPoliciesPolicyIdRoute
  '/home/praetors/$praetorId/cases': typeof AppHomePraetorsPraetorIdCasesIndexRoute
  '/home/praetors/$praetorId/policies': typeof AppHomePraetorsPraetorIdPoliciesIndexRoute
  '/home/praetors/$praetorId/settings': typeof AppHomePraetorsPraetorIdSettingsIndexRoute
  '/home/praetors/$praetorId/cases/v2/$caseId': typeof AppHomePraetorsPraetorIdCasesV2CaseIdRoute
  '/home/praetors/$praetorId/cases/v2': typeof AppHomePraetorsPraetorIdCasesV2IndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_onboarding': typeof OnboardingRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_auth/signin': typeof AuthSigninRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_app/': typeof AppIndexRoute
  '/_app/home/overview': typeof AppHomeOverviewRouteRouteWithChildren
  '/_app/home/users': typeof AppHomeUsersRouteRouteWithChildren
  '/_app/home/directives': typeof AppHomeDirectivesRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_auth/invites/$inviteToken': typeof AuthInvitesInviteTokenRoute
  '/_onboarding/orgs/onboarding': typeof OnboardingOrgsOnboardingRoute
  '/_app/home/': typeof AppHomeIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_onboarding/orgs/': typeof OnboardingOrgsIndexRoute
  '/_app/home/praetors/$praetorId': typeof AppHomePraetorsPraetorIdRouteRouteWithChildren
  '/_app/home/sentences/$sentenceId': typeof AppHomeSentencesSentenceIdRoute
  '/_app/home/users/$actorId': typeof AppHomeUsersActorIdRoute
  '/_app/home/overview/': typeof AppHomeOverviewIndexRoute
  '/_app/home/users/': typeof AppHomeUsersIndexRoute
  '/_app/home/praetors/$praetorId/cases': typeof AppHomePraetorsPraetorIdCasesRouteRouteWithChildren
  '/_app/home/praetors/$praetorId/policies': typeof AppHomePraetorsPraetorIdPoliciesRouteRouteWithChildren
  '/_app/home/overview/onboarding/sdk': typeof AppHomeOverviewOnboardingSdkRoute
  '/_app/home/praetors/$praetorId/': typeof AppHomePraetorsPraetorIdIndexRoute
  '/_app/home/praetors/$praetorId/cases/v2': typeof AppHomePraetorsPraetorIdCasesV2RouteRouteWithChildren
  '/_app/home/praetors/$praetorId/cases/$caseId': typeof AppHomePraetorsPraetorIdCasesCaseIdRoute
  '/_app/home/praetors/$praetorId/policies/$policyId': typeof AppHomePraetorsPraetorIdPoliciesPolicyIdRoute
  '/_app/home/praetors/$praetorId/cases/': typeof AppHomePraetorsPraetorIdCasesIndexRoute
  '/_app/home/praetors/$praetorId/policies/': typeof AppHomePraetorsPraetorIdPoliciesIndexRoute
  '/_app/home/praetors/$praetorId/settings/': typeof AppHomePraetorsPraetorIdSettingsIndexRoute
  '/_app/home/praetors/$praetorId/cases/v2/$caseId': typeof AppHomePraetorsPraetorIdCasesV2CaseIdRoute
  '/_app/home/praetors/$praetorId/cases/v2/': typeof AppHomePraetorsPraetorIdCasesV2IndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/signin'
    | '/signup'
    | '/home/overview'
    | '/home/users'
    | '/home/directives'
    | '/settings/billing'
    | '/settings/members'
    | '/invites/$inviteToken'
    | '/orgs/onboarding'
    | '/home/'
    | '/settings/'
    | '/orgs/'
    | '/home/praetors/$praetorId'
    | '/home/sentences/$sentenceId'
    | '/home/users/$actorId'
    | '/home/overview/'
    | '/home/users/'
    | '/home/praetors/$praetorId/cases'
    | '/home/praetors/$praetorId/policies'
    | '/home/overview/onboarding/sdk'
    | '/home/praetors/$praetorId/'
    | '/home/praetors/$praetorId/cases/v2'
    | '/home/praetors/$praetorId/cases/$caseId'
    | '/home/praetors/$praetorId/policies/$policyId'
    | '/home/praetors/$praetorId/cases/'
    | '/home/praetors/$praetorId/policies/'
    | '/home/praetors/$praetorId/settings/'
    | '/home/praetors/$praetorId/cases/v2/$caseId'
    | '/home/praetors/$praetorId/cases/v2/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/signup'
    | '/home/directives'
    | '/settings/billing'
    | '/settings/members'
    | '/invites/$inviteToken'
    | '/orgs/onboarding'
    | '/home'
    | '/settings'
    | '/orgs'
    | '/home/sentences/$sentenceId'
    | '/home/users/$actorId'
    | '/home/overview'
    | '/home/users'
    | '/home/overview/onboarding/sdk'
    | '/home/praetors/$praetorId'
    | '/home/praetors/$praetorId/cases/$caseId'
    | '/home/praetors/$praetorId/policies/$policyId'
    | '/home/praetors/$praetorId/cases'
    | '/home/praetors/$praetorId/policies'
    | '/home/praetors/$praetorId/settings'
    | '/home/praetors/$praetorId/cases/v2/$caseId'
    | '/home/praetors/$praetorId/cases/v2'
  id:
    | '__root__'
    | '/_app'
    | '/_onboarding'
    | '/_app/settings'
    | '/_auth/signin'
    | '/_auth/signup'
    | '/_app/'
    | '/_app/home/overview'
    | '/_app/home/users'
    | '/_app/home/directives'
    | '/_app/settings/billing'
    | '/_app/settings/members'
    | '/_auth/invites/$inviteToken'
    | '/_onboarding/orgs/onboarding'
    | '/_app/home/'
    | '/_app/settings/'
    | '/_onboarding/orgs/'
    | '/_app/home/praetors/$praetorId'
    | '/_app/home/sentences/$sentenceId'
    | '/_app/home/users/$actorId'
    | '/_app/home/overview/'
    | '/_app/home/users/'
    | '/_app/home/praetors/$praetorId/cases'
    | '/_app/home/praetors/$praetorId/policies'
    | '/_app/home/overview/onboarding/sdk'
    | '/_app/home/praetors/$praetorId/'
    | '/_app/home/praetors/$praetorId/cases/v2'
    | '/_app/home/praetors/$praetorId/cases/$caseId'
    | '/_app/home/praetors/$praetorId/policies/$policyId'
    | '/_app/home/praetors/$praetorId/cases/'
    | '/_app/home/praetors/$praetorId/policies/'
    | '/_app/home/praetors/$praetorId/settings/'
    | '/_app/home/praetors/$praetorId/cases/v2/$caseId'
    | '/_app/home/praetors/$praetorId/cases/v2/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthInvitesInviteTokenRoute: typeof AuthInvitesInviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_onboarding/orgs/': {
      id: '/_onboarding/orgs/'
      path: '/orgs'
      fullPath: '/orgs/'
      preLoaderRoute: typeof OnboardingOrgsIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/home/': {
      id: '/_app/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AppHomeIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_onboarding/orgs/onboarding': {
      id: '/_onboarding/orgs/onboarding'
      path: '/orgs/onboarding'
      fullPath: '/orgs/onboarding'
      preLoaderRoute: typeof OnboardingOrgsOnboardingRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_auth/invites/$inviteToken': {
      id: '/_auth/invites/$inviteToken'
      path: '/invites/$inviteToken'
      fullPath: '/invites/$inviteToken'
      preLoaderRoute: typeof AuthInvitesInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/home/directives': {
      id: '/_app/home/directives'
      path: '/home/directives'
      fullPath: '/home/directives'
      preLoaderRoute: typeof AppHomeDirectivesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/users': {
      id: '/_app/home/users'
      path: '/home/users'
      fullPath: '/home/users'
      preLoaderRoute: typeof AppHomeUsersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/overview': {
      id: '/_app/home/overview'
      path: '/home/overview'
      fullPath: '/home/overview'
      preLoaderRoute: typeof AppHomeOverviewRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/users/': {
      id: '/_app/home/users/'
      path: '/'
      fullPath: '/home/users/'
      preLoaderRoute: typeof AppHomeUsersIndexRouteImport
      parentRoute: typeof AppHomeUsersRouteRoute
    }
    '/_app/home/overview/': {
      id: '/_app/home/overview/'
      path: '/'
      fullPath: '/home/overview/'
      preLoaderRoute: typeof AppHomeOverviewIndexRouteImport
      parentRoute: typeof AppHomeOverviewRouteRoute
    }
    '/_app/home/users/$actorId': {
      id: '/_app/home/users/$actorId'
      path: '/$actorId'
      fullPath: '/home/users/$actorId'
      preLoaderRoute: typeof AppHomeUsersActorIdRouteImport
      parentRoute: typeof AppHomeUsersRouteRoute
    }
    '/_app/home/sentences/$sentenceId': {
      id: '/_app/home/sentences/$sentenceId'
      path: '/home/sentences/$sentenceId'
      fullPath: '/home/sentences/$sentenceId'
      preLoaderRoute: typeof AppHomeSentencesSentenceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/praetors/$praetorId': {
      id: '/_app/home/praetors/$praetorId'
      path: '/home/praetors/$praetorId'
      fullPath: '/home/praetors/$praetorId'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/praetors/$praetorId/': {
      id: '/_app/home/praetors/$praetorId/'
      path: '/'
      fullPath: '/home/praetors/$praetorId/'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdIndexRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdRouteRoute
    }
    '/_app/home/overview/onboarding/sdk': {
      id: '/_app/home/overview/onboarding/sdk'
      path: '/onboarding/sdk'
      fullPath: '/home/overview/onboarding/sdk'
      preLoaderRoute: typeof AppHomeOverviewOnboardingSdkRouteImport
      parentRoute: typeof AppHomeOverviewRouteRoute
    }
    '/_app/home/praetors/$praetorId/policies': {
      id: '/_app/home/praetors/$praetorId/policies'
      path: '/policies'
      fullPath: '/home/praetors/$praetorId/policies'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdPoliciesRouteRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdRouteRoute
    }
    '/_app/home/praetors/$praetorId/cases': {
      id: '/_app/home/praetors/$praetorId/cases'
      path: '/cases'
      fullPath: '/home/praetors/$praetorId/cases'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesRouteRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdRouteRoute
    }
    '/_app/home/praetors/$praetorId/settings/': {
      id: '/_app/home/praetors/$praetorId/settings/'
      path: '/settings'
      fullPath: '/home/praetors/$praetorId/settings/'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdSettingsIndexRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdRouteRoute
    }
    '/_app/home/praetors/$praetorId/policies/': {
      id: '/_app/home/praetors/$praetorId/policies/'
      path: '/'
      fullPath: '/home/praetors/$praetorId/policies/'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdPoliciesIndexRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdPoliciesRouteRoute
    }
    '/_app/home/praetors/$praetorId/cases/': {
      id: '/_app/home/praetors/$praetorId/cases/'
      path: '/'
      fullPath: '/home/praetors/$praetorId/cases/'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesIndexRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdCasesRouteRoute
    }
    '/_app/home/praetors/$praetorId/policies/$policyId': {
      id: '/_app/home/praetors/$praetorId/policies/$policyId'
      path: '/$policyId'
      fullPath: '/home/praetors/$praetorId/policies/$policyId'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdPoliciesPolicyIdRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdPoliciesRouteRoute
    }
    '/_app/home/praetors/$praetorId/cases/$caseId': {
      id: '/_app/home/praetors/$praetorId/cases/$caseId'
      path: '/$caseId'
      fullPath: '/home/praetors/$praetorId/cases/$caseId'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesCaseIdRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdCasesRouteRoute
    }
    '/_app/home/praetors/$praetorId/cases/v2': {
      id: '/_app/home/praetors/$praetorId/cases/v2'
      path: '/v2'
      fullPath: '/home/praetors/$praetorId/cases/v2'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesV2RouteRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdCasesRouteRoute
    }
    '/_app/home/praetors/$praetorId/cases/v2/': {
      id: '/_app/home/praetors/$praetorId/cases/v2/'
      path: '/'
      fullPath: '/home/praetors/$praetorId/cases/v2/'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesV2IndexRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdCasesV2RouteRoute
    }
    '/_app/home/praetors/$praetorId/cases/v2/$caseId': {
      id: '/_app/home/praetors/$praetorId/cases/v2/$caseId'
      path: '/$caseId'
      fullPath: '/home/praetors/$praetorId/cases/v2/$caseId'
      preLoaderRoute: typeof AppHomePraetorsPraetorIdCasesV2CaseIdRouteImport
      parentRoute: typeof AppHomePraetorsPraetorIdCasesV2RouteRoute
    }
  }
}

interface AppSettingsRouteRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppHomeOverviewRouteRouteChildren {
  AppHomeOverviewIndexRoute: typeof AppHomeOverviewIndexRoute
  AppHomeOverviewOnboardingSdkRoute: typeof AppHomeOverviewOnboardingSdkRoute
}

const AppHomeOverviewRouteRouteChildren: AppHomeOverviewRouteRouteChildren = {
  AppHomeOverviewIndexRoute: AppHomeOverviewIndexRoute,
  AppHomeOverviewOnboardingSdkRoute: AppHomeOverviewOnboardingSdkRoute,
}

const AppHomeOverviewRouteRouteWithChildren =
  AppHomeOverviewRouteRoute._addFileChildren(AppHomeOverviewRouteRouteChildren)

interface AppHomeUsersRouteRouteChildren {
  AppHomeUsersActorIdRoute: typeof AppHomeUsersActorIdRoute
  AppHomeUsersIndexRoute: typeof AppHomeUsersIndexRoute
}

const AppHomeUsersRouteRouteChildren: AppHomeUsersRouteRouteChildren = {
  AppHomeUsersActorIdRoute: AppHomeUsersActorIdRoute,
  AppHomeUsersIndexRoute: AppHomeUsersIndexRoute,
}

const AppHomeUsersRouteRouteWithChildren =
  AppHomeUsersRouteRoute._addFileChildren(AppHomeUsersRouteRouteChildren)

interface AppHomePraetorsPraetorIdCasesV2RouteRouteChildren {
  AppHomePraetorsPraetorIdCasesV2CaseIdRoute: typeof AppHomePraetorsPraetorIdCasesV2CaseIdRoute
  AppHomePraetorsPraetorIdCasesV2IndexRoute: typeof AppHomePraetorsPraetorIdCasesV2IndexRoute
}

const AppHomePraetorsPraetorIdCasesV2RouteRouteChildren: AppHomePraetorsPraetorIdCasesV2RouteRouteChildren =
  {
    AppHomePraetorsPraetorIdCasesV2CaseIdRoute:
      AppHomePraetorsPraetorIdCasesV2CaseIdRoute,
    AppHomePraetorsPraetorIdCasesV2IndexRoute:
      AppHomePraetorsPraetorIdCasesV2IndexRoute,
  }

const AppHomePraetorsPraetorIdCasesV2RouteRouteWithChildren =
  AppHomePraetorsPraetorIdCasesV2RouteRoute._addFileChildren(
    AppHomePraetorsPraetorIdCasesV2RouteRouteChildren,
  )

interface AppHomePraetorsPraetorIdCasesRouteRouteChildren {
  AppHomePraetorsPraetorIdCasesV2RouteRoute: typeof AppHomePraetorsPraetorIdCasesV2RouteRouteWithChildren
  AppHomePraetorsPraetorIdCasesCaseIdRoute: typeof AppHomePraetorsPraetorIdCasesCaseIdRoute
  AppHomePraetorsPraetorIdCasesIndexRoute: typeof AppHomePraetorsPraetorIdCasesIndexRoute
}

const AppHomePraetorsPraetorIdCasesRouteRouteChildren: AppHomePraetorsPraetorIdCasesRouteRouteChildren =
  {
    AppHomePraetorsPraetorIdCasesV2RouteRoute:
      AppHomePraetorsPraetorIdCasesV2RouteRouteWithChildren,
    AppHomePraetorsPraetorIdCasesCaseIdRoute:
      AppHomePraetorsPraetorIdCasesCaseIdRoute,
    AppHomePraetorsPraetorIdCasesIndexRoute:
      AppHomePraetorsPraetorIdCasesIndexRoute,
  }

const AppHomePraetorsPraetorIdCasesRouteRouteWithChildren =
  AppHomePraetorsPraetorIdCasesRouteRoute._addFileChildren(
    AppHomePraetorsPraetorIdCasesRouteRouteChildren,
  )

interface AppHomePraetorsPraetorIdPoliciesRouteRouteChildren {
  AppHomePraetorsPraetorIdPoliciesPolicyIdRoute: typeof AppHomePraetorsPraetorIdPoliciesPolicyIdRoute
  AppHomePraetorsPraetorIdPoliciesIndexRoute: typeof AppHomePraetorsPraetorIdPoliciesIndexRoute
}

const AppHomePraetorsPraetorIdPoliciesRouteRouteChildren: AppHomePraetorsPraetorIdPoliciesRouteRouteChildren =
  {
    AppHomePraetorsPraetorIdPoliciesPolicyIdRoute:
      AppHomePraetorsPraetorIdPoliciesPolicyIdRoute,
    AppHomePraetorsPraetorIdPoliciesIndexRoute:
      AppHomePraetorsPraetorIdPoliciesIndexRoute,
  }

const AppHomePraetorsPraetorIdPoliciesRouteRouteWithChildren =
  AppHomePraetorsPraetorIdPoliciesRouteRoute._addFileChildren(
    AppHomePraetorsPraetorIdPoliciesRouteRouteChildren,
  )

interface AppHomePraetorsPraetorIdRouteRouteChildren {
  AppHomePraetorsPraetorIdCasesRouteRoute: typeof AppHomePraetorsPraetorIdCasesRouteRouteWithChildren
  AppHomePraetorsPraetorIdPoliciesRouteRoute: typeof AppHomePraetorsPraetorIdPoliciesRouteRouteWithChildren
  AppHomePraetorsPraetorIdIndexRoute: typeof AppHomePraetorsPraetorIdIndexRoute
  AppHomePraetorsPraetorIdSettingsIndexRoute: typeof AppHomePraetorsPraetorIdSettingsIndexRoute
}

const AppHomePraetorsPraetorIdRouteRouteChildren: AppHomePraetorsPraetorIdRouteRouteChildren =
  {
    AppHomePraetorsPraetorIdCasesRouteRoute:
      AppHomePraetorsPraetorIdCasesRouteRouteWithChildren,
    AppHomePraetorsPraetorIdPoliciesRouteRoute:
      AppHomePraetorsPraetorIdPoliciesRouteRouteWithChildren,
    AppHomePraetorsPraetorIdIndexRoute: AppHomePraetorsPraetorIdIndexRoute,
    AppHomePraetorsPraetorIdSettingsIndexRoute:
      AppHomePraetorsPraetorIdSettingsIndexRoute,
  }

const AppHomePraetorsPraetorIdRouteRouteWithChildren =
  AppHomePraetorsPraetorIdRouteRoute._addFileChildren(
    AppHomePraetorsPraetorIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppHomeOverviewRouteRoute: typeof AppHomeOverviewRouteRouteWithChildren
  AppHomeUsersRouteRoute: typeof AppHomeUsersRouteRouteWithChildren
  AppHomeDirectivesRoute: typeof AppHomeDirectivesRoute
  AppHomeIndexRoute: typeof AppHomeIndexRoute
  AppHomePraetorsPraetorIdRouteRoute: typeof AppHomePraetorsPraetorIdRouteRouteWithChildren
  AppHomeSentencesSentenceIdRoute: typeof AppHomeSentencesSentenceIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppHomeOverviewRouteRoute: AppHomeOverviewRouteRouteWithChildren,
  AppHomeUsersRouteRoute: AppHomeUsersRouteRouteWithChildren,
  AppHomeDirectivesRoute: AppHomeDirectivesRoute,
  AppHomeIndexRoute: AppHomeIndexRoute,
  AppHomePraetorsPraetorIdRouteRoute:
    AppHomePraetorsPraetorIdRouteRouteWithChildren,
  AppHomeSentencesSentenceIdRoute: AppHomeSentencesSentenceIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingOrgsOnboardingRoute: typeof OnboardingOrgsOnboardingRoute
  OnboardingOrgsIndexRoute: typeof OnboardingOrgsIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingOrgsOnboardingRoute: OnboardingOrgsOnboardingRoute,
  OnboardingOrgsIndexRoute: OnboardingOrgsIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthInvitesInviteTokenRoute: AuthInvitesInviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
